import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditRichTextTemplate} from "./FormEditRichTextTemplate";
import {FormEditStructuredTemplate} from "./FormEditStructuredTemplate";

export const PanelEditEmailTemplate = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    name: "",
    similar_terms: "",
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.EmailTemplates.GetOne}${id}`,
      });

      if (response) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Email Template <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Email Template: {data?.name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
              data.type === 'rich_text' ?

            <FormEditRichTextTemplate data={data} setData={setData} /> :
                  <FormEditStructuredTemplate data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};
